import { render, staticRenderFns } from "./customBtn.vue?vue&type=template&id=7e1f2292&scoped=true&"
import script from "./customBtn.vue?vue&type=script&lang=js&"
export * from "./customBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1f2292",
  null
  
)

export default component.exports